var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_3814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_86_3814)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 20,
    rx: 2.5,
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.881 0H2.61905C1.17259 0 0 1.19391 0 2.66667V17.3333C0 18.8061 1.17259 20 2.61905 20H24.881C26.3274 20 27.5 18.8061 27.5 17.3333V2.66667C27.5 1.19391 26.3274 0 24.881 0Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.33325H27.5V14.6666H0V5.33325Z",
    fill: "#FFDA2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7859 8.29597V11.656C11.7859 12.5893 10.9059 13.336 9.82161 13.336H7.20257C6.1209 13.3333 5.23828 12.5826 5.23828 11.6533V8.2933C5.23828 7.53063 5.82495 6.8933 6.63161 6.68663C6.87519 5.9933 7.62423 6.61463 8.51209 6.61463C9.40519 6.61463 10.149 5.9973 10.3926 6.68797C11.1966 6.89997 11.7859 7.53863 11.7859 8.29597Z",
    fill: "#D4AF2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7854 9.33325H13.0949V13.3333H11.7854V9.33325ZM3.92822 9.33325H5.23775V13.3333H3.92822V9.33325Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7854 12H13.0949V13.3333H11.7854V12ZM3.92822 12H5.23775V13.3333H3.92822V12Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7854 8H13.0949V9.33333H11.7854V8ZM3.92822 8H5.23775V9.33333H3.92822V8Z",
    fill: "#D4AF2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54785 8H7.85738V10H6.54785V8ZM9.1669 10.6667H10.4764V12.6667H9.1669V10.6667Z",
    fill: "#AF010D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16602 8H10.4755V10H9.16602V8Z",
    fill: "#AE6A3E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54785 10.6667H7.85738V12.6667H6.54785V10.6667Z",
    fill: "#FFDA2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85738 8.00008L6.54785 6.66675H10.4764L9.1669 8.00008H7.85738Z",
    fill: "#AF010D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85742 5.33325H9.16695V6.66659H7.85742V5.33325Z",
    fill: "#D4AF2C"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    y: 0.625,
    width: 26.25,
    height: 18.75,
    stroke: "#F9F2F2",
    strokeWidth: 1.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_3814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_86_3814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 20,
    rx: 2.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/es.af5ca1de3a544bca4a1d783ebd3ba269.svg";
export { ForwardRef as ReactComponent };